import React from 'react';
import { Typography } from '@mui/material';
import { BaseDialog } from 'src/components/BaseDialog/BaseDialog';
import { ts } from 'src/utils/translate';
import { theme } from 'src/theme/mui-theme';

type Props = {
    open: boolean;
    onClose: () => void;
    onGoThere: () => void;
};

export const AddressRequiredDialog = ({ open, onClose, onGoThere }: Props) => {
    return (
        <BaseDialog
            open={open}
            onClose={onClose}
            title={ts('warning', 'Warning!')}
            maxWidth="xs"
            cancelLabel={ts('plt_cancel', 'Cancel')}
            actionLabel={ts('c_go_there', 'Go there')}
            onAction={onGoThere}
        >
            <Typography variant="body2" color={theme.palette.text.secondary}>
                {ts('fill_address_please', 'Fill out address details to invite people!')}
            </Typography>
        </BaseDialog>
    );
};
